import React from 'react';
import withStyles from 'react-jss';
import classNames from 'classnames';

const barFillColor = {
  emptyColor: () => ({
    color: 'light-grey',
  }),
  fillColor: (props) => ({
    background: props.tenant.secondary,
  }),
};

function ClassesProgressBar({ classes, numBars, barsFilled }) {
  const makeProgressBar = (numberBars) => {
    const barArray = [];

    for (let i = 0; i < numberBars; i++) {
      let thisBar;

      if (i < barsFilled) {
        thisBar = (
          <hr
            className={classNames('single-progress-bar', classes.fillColor)}
            key={Math.random()}
          />
        );
      } else {
        thisBar = (
          <hr
            className={classNames('single-progress-bar', classes.emptyColor)}
            key={Math.random()}
          />
        );
      }

      barArray.push(thisBar);
    }

    return barArray;
  };

  return <div className="class-progress-bar">{makeProgressBar(numBars)}</div>;
}

export default withStyles(barFillColor)(ClassesProgressBar);
